<script>
import Header from "@/components/Header.vue";
import axios from "axios";
import ListControls from "@/components/listControls.vue";
import _ from "lodash";
import ModalLog from "@/components/ModalLog.vue";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "Task",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {ModalLog, ListControls, Header},
  data() {
    return {
      sortField: localStorage.getItem("taskSort") ?? "Id",
      tasks: [],
      taskData: null,
      taskModalTitle: null,
      total: null,
      limit: localStorage.getItem("taskLimit") ?? 50,
      page: this.$route.query.page ?? 1,
      taskForShow: this.$route.query.task ?? null,
      filter: {
        Id: this.$route.query.task ?? null,
        Status: null
      },
      filterOptions: {
        Status: [
          {label: "Planned", value: 1},
          {label: "Process", value: 2},
          {label: "Stopped", value: 3}
        ]
      }
    }
  },
  methods: {
    showTask(item) {
      this.taskData = item.Result;
      this.taskModalTitle = `Result for task ${item.Id} - ${item.Name}`
      this.$modal.show('taskResult');
    },
    changeFilterValue(event, filter) {
      this.filter[filter] = event === null ? "" : event.value
      this.getTasks()
    },
    ChangeLimit(newLimit) {
      this.limit = newLimit;
      localStorage.setItem('taskLimit', newLimit)
      this.getTasks();
    },
    SortInvert(field) {
      if (field === this.sortField) {
        this.sortField = '-' + field
      } else {
        this.sortField = field
      }
      localStorage.setItem('taskSort', this.sortField)
      this.getTasks();
    },
    getTasks() {
      const apiUrl = `api/task/list?limit=${this.limit}&sort=${this.sortField}&page=${this.page}`;
      const payload = _.map(this.filter, (value, key) => {
            if (value !== null && value.length > 0) {
              if (key === "Status") {
                return {
                  "Condition": "=",
                  "Data": {"Status": value}
                }
              } else if (key === "Id") {
                return {
                  "Condition": "=",
                  "Data": {"Id": value}

                }
              }
            }
          }
      )
      axios.post(apiUrl, payload, this.authRespConf()).then((response) => {
        this.total = response.data.total;
        this.tasks = response.data.data;
        if (this.taskForShow) {
          const Id = this.taskForShow
          const task = _.find(this.tasks, {Id})
          if (task) {
            this.showTask(task)
          }
        }
      })
    }
  },
  watch: {
    '$route.query.page'(newVal) {
      this.page = newVal
      this.getTasks()
    },
    '$route.query.task'(newVal) {
      if (newVal) {
        this.taskForShow = newVal
      }
    },
    'taskForShow' (val) {
      const task = _.find(this.tasks, {Id: val})
      if (task) {
        this.showTask(task)
      }
    }
  },
  created: function () {
    this.getTasks()
  }
}
</script>

<template>
  <div class="page">
    <Header title="task page"/>
    <div class="container dashboard card">
      <div class="card-header">
        Tasks
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Status')">Status</span>
              <span class="icon-up" v-show="sortField === 'Status'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Status'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 7rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('Name')">Name</span>
              <span class="icon-up" v-show="sortField === 'Name'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Name'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Details')">Details</span>
              <span class="icon-up" v-show="sortField === 'Details'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Details'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('UserId')">UserId</span>
              <span class="icon-up" v-show="sortField === 'UserId'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'UserId'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('StartedAt')">StartedAt</span>
              <span class="icon-up" v-show="sortField === 'StartedAt'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'StartedAt'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('StoppedAt')">StoppedAt</span>
              <span class="icon-up" v-show="sortField === 'StoppedAt'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'StoppedAt'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
          </tr>
          <tr @keyup.enter="getTasks">
            <th>
              <b-form-input v-model="filter.Id" placeholder="Id"></b-form-input>
            </th>
            <th>
              <v-select :options="filterOptions.Status" @input="changeFilterValue($event, 'Status')"
                        :value="filter.Status"
                        :clearable="true" inputId="status"
                        placeholder="ANY"/>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in tasks"
              v-bind:key="item.id"
              class="cursor-pointer"
              @click="showTask(item)"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span class="cel-text">
                <span v-if="item.Status === 1" style="all: initial;">Planned</span>
                <span v-else-if="item.Status === 2" style="all: initial;">Process</span>
                <span v-else-if="item.Status === 3" style="all: initial;">Stopped</span>
              </span>
            </td>
            <td>
              <span class="cel-text">{{ item.Name }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Details }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.UserId }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.StartedAt }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.StoppedAt }}</span>
            </td>

          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="tasks?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
        <ModalLog modalName="taskResult" :title="taskModalTitle" :data="taskData"/>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>